import * as React from 'react';
import classnames from 'classnames';
import { SubscriptionContainer } from '../containers/SubscriptionContainer.js';

const Subscription = ({ className , lineItems , hideSubscriptionExplainer , subscription  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('cart-totals', className),
        "data-t": "cart-totals"
    }, /*#__PURE__*/ React.createElement(SubscriptionContainer, {
        lineItems: lineItems,
        subscription: subscription,
        hideSubscriptionExplainer: hideSubscriptionExplainer
    }))
;

export { Subscription };
//# sourceMappingURL=Subscription.js.map
